import { defineStore } from 'pinia';
import { computed, ref } from 'vue';

// Holds the single pending internal link whose warning dialog is open. StationCard requests a URL,
// InternalLinkWarningModal (mounted once in App.vue) renders the confirm dialog and opens the link.
const useLinkWarningStore = defineStore('linkWarning', () => {
  const pendingUrl = ref(null);
  const open = computed(() => pendingUrl.value !== null);

  function request(url) {
    pendingUrl.value = url;
  }

  function confirm() {
    const url = pendingUrl.value;
    pendingUrl.value = null;
    // Runs inside the modal button's click gesture, so the popup blocker allows it.
    if (url) window.open(url, '_blank', 'noopener');
  }

  function cancel() {
    pendingUrl.value = null;
  }

  return {
    pendingUrl,
    open,
    request,
    confirm,
    cancel,
  };
});

export default useLinkWarningStore;
